import { Empty, Typography } from 'antd'

export const EmptyListDefault = ({ resource = 'entries' }) => {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={<Typography.Text>No {resource} found</Typography.Text>}
    ></Empty>
  )
}
